import { useTranslation } from 'react-i18next';
import { Paper, Stack, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';
import CarbonRatingChip from '../../RecipeV2/components/CarbonRatingChip';

interface CarbonSustainabilityTabProps {
  item: RangePlanningItem;
}

const ratingCopy: Record<string, string> = {
  A: 'Very low carbon footprint relative to category average.',
  B: 'Below average carbon footprint for this category.',
  C: 'Average carbon footprint for this category.',
  D: 'Above average carbon footprint for this category.',
  E: 'High carbon footprint - consider lower-carbon alternatives.',
};

/** Reuses RecipeV2's CarbonRatingChip and CarbonRating enum directly - the same A-E scale
 * is used for both recipes and items. */
const CarbonSustainabilityTab = ({ item }: CarbonSustainabilityTabProps) => {
  const { t } = useTranslation('rangePlanningItems');

  return (
    <Paper variant="outlined"
      sx={{ p: 4 }}>
      <Stack spacing={3}>
        <Stack direction="row"
          alignItems="center"
          spacing={2}>
          <CarbonRatingChip rating={item.carbonRating}
            size="medium" />
          <Typography variant="textMD">
            {t(`carbonRatingCopy.${item.carbonRating}`, ratingCopy[item.carbonRating])}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default CarbonSustainabilityTab;
